import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";

const tools = [
  { name: "Selenium", desc: "Automate browser-based web application testing across major browsers.", logo: "/images/selenium.svg" },
  { name: "Playwright", desc: "Modern end-to-end testing framework for fast and reliable automation.", logo: "/images/playwright.svg" },
  { name: "Postman", desc: "API testing and validation for REST and SOAP services.", logo: "/images/postman.svg" },
  { name: "Pytest", desc: "Python testing framework for scalable unit and functional test automation.", logo: "/images/pytest.svg" },
  { name: "Maven", desc: "Build automation and dependency management for Java projects.", logo: "/images/java-script.png" },
  { name: "Docker", desc: "Containerization for consistent test environments and isolated execution.", logo: "/images/docker.png" },
  { name: "AWS", desc: "Cloud infrastructure for running automated tests and deployment workflows at scale.", logo: "/images/Aws.png" },
  { name: "Python", desc: "Modern scripting language used for automation scripts, API testing, and backend validation.", logo: "/images/python.svg" },
  { name: "TestNG", desc: "Robust test framework for organizing and executing automated test suites.", logo: "/images/testng.svg" },
  { name: "Jenkins", desc: "Continuous integration for running automated tests in CI/CD pipelines.", logo: "/images/Jenkins.png" },
  { name: "GitHub Actions", desc: "CI workflow automation for running tests on every code push.", logo: "/images/github.png" },
  { name: "Allure", desc: "Detailed reporting and dashboarding for test execution results.", logo: "/images/allure.svg" },
  { name: "Java", desc: "Core language used widely in enterprise test automation frameworks.", logo: "/images/java-script.png" }
];

const AutomationTesting = () => {
  return (
    <Container className="my-5 page-shell">
      <div className="page-header text-center mb-5">
        <span className="eyebrow dark">Automation Testing</span>
        <h1 className="fw-bold mt-3 mb-3">Test Automation Excellence</h1>
        <p className="page-subtitle mx-auto">
          Build reliable, scalable, and maintainable automation frameworks that improve quality,
          accelerate delivery, and reduce release risk across web and API applications.
        </p>
      </div>

      <Row className="g-4 mb-5">
        {tools.map((tool, index) => (
          <Col key={index} xs={12} sm={6} md={4} lg={3}>
            <Card className="h-100 shadow-sm text-center p-3 info-card border-0">
              {tool.logo && (
                <Card.Img
                  variant="top"
                  src={tool.logo}
                  alt={tool.name}
                  style={{ width: "80px", height: "80px", objectFit: "contain", margin: "0 auto" }}
                  className="mb-3"
                />
              )}
              <Card.Body>
                <Card.Title>{tool.name}</Card.Title>
                <Card.Text>{tool.desc}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

    </Container>
  );
};

export default AutomationTesting;
